<template>
    <v-card class="pa-5" dark>
        <v-toolbar class="text-overline" dark>Seed Stock - Confirm Address & Contact Information</v-toolbar>
        <v-col cols="12">
            <base-divider class="mt-5 mb-0" color="primary" space="3" max-width="100%" />
        </v-col>
        <v-row class="pa-3 pt-0">
            <info-input
                :info-type="'Shipping'"
                :value="{ contact: contact.shipping, address: address.shipping }"
            ></info-input>
        </v-row>
        <v-row class="mt-0">
            <v-col cols="2">
                <v-btn elevation="0" text @click="$emit('cancel')">Cancel</v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2">
                <v-btn
                    dark
                    elevation="0"
                    :disabled="!formIsValid"
                    @click="$emit('confirmed', { contact: contact.shipping, address: address.shipping })"
                    >Confirm</v-btn
                >
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import formRules from '@/utils/form_rules'
import InfoInput from './info_input.vue'
import gql from 'graphql-tag'

export default {
    name: 'ConfirmInfo',
    components: { InfoInput },
    apollo: {
        querySMCustomer: {
            query: gql`
                query QuerySMCustomer($customerId: String!) {
                    querySMCustomer(customerId: $customerId) {
                        shipping {
                            address {
                                APO
                                company
                                line1
                                line2
                                city
                                state
                                country
                                postalCode
                                international
                            }
                            contact {
                                firstName
                                lastName
                                fullName
                                email
                                phone
                                company
                                position
                            }
                        }
                        smConfirmed
                    }
                }
            `,
            skip() {
                return !this.$auth.user.org.branchId
            },
            variables() {
                return {
                    customerId: this.$auth.user.org.branchId
                }
            },
            update(data) {
                const customer = data.querySMCustomer
                if (customer && customer.shipping) {
                    if (customer.contact) {
                        this.contact.shipping = {
                            company: customer.contact.company || ``,
                            firstName: customer.contact.firstName || ``,
                            lastName: customer.contact.lastName || ``,
                            email: customer.contact.email || ``,
                            phone: customer.contact.phone || ``,
                            phoneCountryCode: ``
                        }
                    }
                    if (customer.address) {
                        this.address.shipping = {
                            country: customer.address.country || ``,
                            line1: customer.address.line1 || ``,
                            line2: customer.address.line2 || ``,
                            city: customer.address.city || ``,
                            state: customer.address.state || ``,
                            postalCode: customer.address.postalCode || ``
                        }
                    }
                }
            }
        }
    },
    data() {
        return {
            formRules,
            phoneInput: ``,
            contact: {
                billing: {
                    company: ``,
                    firstName: ``,
                    lastName: ``,
                    email: ``,
                    phone: ``,
                    phoneCountryCode: ``
                },
                shipping: {
                    company: ``,
                    firstName: ``,
                    lastName: ``,
                    email: ``,
                    phone: ``,
                    phoneCountryCode: ``
                }
            },
            address: {
                billing: {
                    line1: ``,
                    line2: ``,
                    city: ``,
                    state: ``,
                    postalCode: ``
                },
                shipping: {
                    line1: ``,
                    line2: ``,
                    city: ``,
                    state: ``,
                    postalCode: ``
                }
            },
            formInput: {
                company: ``,
                firstName: ``,
                lastName: ``,
                email: ``,
                phone: ``,
                phoneCountryCode: ``
            }
        }
    },
    computed: {
        formIsValid() {
            const contact =
                !!this.contact.shipping.company &&
                !!this.contact.shipping.firstName &&
                !!this.contact.shipping.lastName &&
                !!this.contact.shipping.email &&
                !!this.contact.shipping.phone
            const address =
                !!this.address.shipping.line1 &&
                !!this.address.shipping.city &&
                !!this.address.shipping.state &&
                !!this.address.shipping.postalCode
            return contact && address
        },
        oidcBilling() {
            return this.$auth.user.address ? this.$auth.user.address.billing : {}
        },
        oidcShipping() {
            return this.$auth.user.address ? this.$auth.user.address.shipping : {}
        }
    },
    methods: {
        assignPhone(a) {
            // eslint-disable-next-line no-unused-vars
            const [input, phoneObject] = a
            this.phoneValid = phoneObject.nationalNumber ? !!phoneObject.valid : true
            this.formInput.phone = phoneObject.nationalNumber
            this.formInput.phoneCountryCode = phoneObject.countryCode
        }
    }
}
</script>
